import React, { useEffect, useState, useRef } from "react";
import "./CtaSection.scss";
import AnimatedSection from "../../components/Ui/AnimatedSection";
import { Phone, Code, Briefcase, Zap, Star, MessageSquare } from "lucide-react";

const CtaSection = () => {
  const [clients, setClients] = useState(0);
  const [companies, setCompanies] = useState(0);
  const [projects, setProjects] = useState(0);
  const statsRef = useRef(null);
  const [hasAnimated, setHasAnimated] = useState(false);

  // Scroll pe count start
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          setHasAnimated(true);

          // Clients: 20+
          let c = 0;
          const t1 = setInterval(() => {
            c += 1;
            if (c >= 20) { setClients(20); clearInterval(t1); }
            else setClients(c);
          }, 70);

          // Companies: 10+
          let com = 0;
          const t2 = setInterval(() => {
            com += 1;
            if (com >= 10) { setCompanies(10); clearInterval(t2); }
            else setCompanies(com);
          }, 120);

          // Projects: 80+
          let p = 0;
          const t3 = setInterval(() => {
            p += 3;
            if (p >= 80) { setProjects(80); clearInterval(t3); }
            else setProjects(p);
          }, 25);
        }
      },
      { threshold: 0.4 }
    );

    if (statsRef.current) observer.observe(statsRef.current);
    return () => observer.disconnect();
  }, [hasAnimated]);

  return (
    <section className="cta-clean-design">
      
      {/* Floating Icons */}
      <div className="floating-icons-container">
        <Zap className="floating-icon icon-1" style={{ '--x': '10%', '--y': '20%', '--size': '40px', '--speed': '12s' }} />
        <Code className="floating-icon icon-2" style={{ '--x': '85%', '--y': '15%', '--size': '50px', '--speed': '10s' }} />
        <Briefcase className="floating-icon icon-3" style={{ '--x': '50%', '--y': '5%', '--size': '30px', '--speed': '15s' }} />
        <Star className="floating-icon icon-4" style={{ '--x': '5%', '--y': '80%', '--size': '35px', '--speed': '14s' }} />
        <MessageSquare className="floating-icon icon-5" style={{ '--x': '90%', '--y': '70%', '--size': '45px', '--speed': '11s' }} />
      </div>

      <div className="cta-container-v2">
        <div className="cta-main-grid">

          {/* LEFT: Header */}
          <div className="cta-header-wrap">
            <AnimatedSection delay={100}>
              <div className="cta-header-v2">
                <h1 className="main-title">Ready to Discuss Your Next Project?</h1>
                <p className="subtitle-v2">
                  Let's start the conversation. Schedule a consultation with our expert team today. 
                  We specialize in delivering high-impact, custom digital solutions.
                </p>
              </div>
            </AnimatedSection>

            {/* Stats with Different Colors - INLINE STYLES */}
            <AnimatedSection delay={600}>
              <div className="stats-number-row-clean" ref={statsRef}>
                
                {/* 1. Happy Clients - YELLOW */}
                <div className="stat-number-box-clean">
                  <h3 className="stat-value-clean">
                    <span style={{ 
                      color: '#ffb300', 
                      textShadow: '0 0 25px rgba(255,179,0,0.6)',
                      fontWeight: '900'
                    }}>
                      {clients}
                    </span>
                    <span style={{ 
                      color: '#ff8c00', 
                      fontSize: '2.4rem', 
                      fontWeight: '800',
                      textShadow: '0 0 15px rgba(255,140,0,0.7)'
                    }}>+</span>
                  </h3>
                  <p className="stat-label-clean">Happy Clients</p>
                </div>

                {/* 2. Companies - PINK */}
                <div className="stat-number-box-clean">
                  <h3 className="stat-value-clean">
                    <span style={{ 
                      color: '#e91e63', 
                      textShadow: '0 0 25px rgba(233,30,99,0.6)',
                      fontWeight: '900'
                    }}>
                      {companies}
                    </span>
                    <span style={{ 
                      color: '#c2185b', 
                      fontSize: '2.4rem', 
                      fontWeight: '800',
                      textShadow: '0 0 15px rgba(194,24,91,0.7)'
                    }}>+</span>
                  </h3>
                  <p className="stat-label-clean">Companies</p>
                </div>

                {/* 3. Projects Done - CYAN */}
                <div className="stat-number-box-clean">
                  <h3 className="stat-value-clean">
                    <span style={{ 
                      color: '#00bcd4', 
                      textShadow: '0 0 25px rgba(0,188,212,0.6)',
                      fontWeight: '900'
                    }}>
                      {projects}
                    </span>
                    <span style={{ 
                      color: '#0097a7', 
                      fontSize: '2.4rem', 
                      fontWeight: '800',
                      textShadow: '0 0 15px rgba(0,151,167,0.7)'
                    }}>+</span>
                  </h3>
                  <p className="stat-label-clean">Projects </p>
                </div>

              </div>
            </AnimatedSection>
          </div>

          {/* RIGHT: Call Card */}
          <AnimatedSection delay={400}>
            <div className="call-card-clean hover-shadow">
              <div className="phone-icon-box">
                <Phone className="icon-blue-ring" />
              </div>
              <h4 className="call-label-v2">CALL US DIRECTLY</h4>
              <a href="tel:+912067622438" className="number-link-v2">
                (+91) 20-67622438
              </a>
              <p className="contact-note-v2">
                Have any idea or project in your mind? Call us or schedule an appointment. 
                Our representative will reply shortly.
              </p>
            </div>
          </AnimatedSection>

        </div>
      </div>
    </section>
  );
};

export default CtaSection;